import { type Registry as Services, service } from '@ember/service';
import BaseStorageService from 'frontend-payments/services/base/storage';

export const LOCAL_STORAGE_KEYS = {
  RATE_TABLE_COLUMNS: 'rate-table-columns',
  BUDGET_FORECAST_DISTRIBUTION_METHOD: 'budget-forecast-distribution-method',
};

export default class LocalStorageService extends BaseStorageService {
  @service declare errorTracking: Services['error-tracking'];

  constructor() {
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);
    try {
      this.intendedStorage = window.localStorage;
    } catch {
      this.intendedStorage = {};
      this.errorTracking.addBreadcrumb({
        message: 'Could not access localStorage',
      });
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'local-storage': LocalStorageService;
  }
}
